import { connect } from "react-redux";
import MyLicenses, {MyLicensesProps as _MyLicensesProps} from "./my-licenses-container";
import {MyLicensesReduxProps} from "./my-licenses-view";
import {PickReduxDispatchProps, PickReduxStateProps} from "../../../util/typeUtil";
import {ActionSender} from "../../../model/ActionSender";
import {AppState} from "../../../redux/store/AppState";
import InProgressUtils from "../../../redux/util/inProgressUtils";
import LicensesUtils from "../../../redux/util/licenseUtils";
import {queryAvailableLicenses} from "../../../redux/actions/entActions";
import AuthenticationUtils from "../../../redux/util/authenticationUtils";

// Own props, i.e. props that this component takes as input
interface MyLicensesProps extends Omit<_MyLicensesProps, keyof MyLicensesReduxProps> {}

// Input props provided to the wrapped component by this connect component, using mapStateToProps
type ReduxStateProps = PickReduxStateProps<_MyLicensesProps, MyLicensesProps>;
// Dispatch props provided to the wrapped component by this connect component
type ReduxDispatchProps = PickReduxDispatchProps<_MyLicensesProps, MyLicensesProps>;

const sender: ActionSender = { key: "my-licenses" };

function mapStateToProps(state: AppState): ReduxStateProps {
  return {
    isReady: InProgressUtils.selectNotInProgress(sender.key, state),
    licenses: LicensesUtils.selectLicenses(state),
    userId: AuthenticationUtils.selectUserId(state),
  }
}

function areStatesEqual(next: AppState, prev: AppState): boolean {
  return (
      InProgressUtils.compareInProgressStates(next, prev) &&
      LicensesUtils.compareLicensesStates(next, prev)
  );
}
const dispatchActions: ReduxDispatchProps = {
  onLoadLicenses: (userId: string) => queryAvailableLicenses(sender, userId)

};

export default connect<
    ReduxStateProps,
    ReduxDispatchProps,
    MyLicensesProps,
    AppState>(
    mapStateToProps,
    dispatchActions,
    null,
    {
      areStatesEqual,
    }
)(MyLicenses);
